var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colors } from '../utils/theme';
var FixedFooter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  z-index: 999;\n  width: 100%;\n  padding: 1rem;\n  background-color: ", ";\n"], ["\n  position: fixed;\n  bottom: 0;\n  z-index: 999;\n  width: 100%;\n  padding: 1rem;\n  background-color: ", ";\n"])), colors.primary);
export default FixedFooter;
var templateObject_1;
